import { render, staticRenderFns } from "./TermsAndConditionsDetails.vue?vue&type=template&id=9bf49c68&scoped=true&"
import script from "./TermsAndConditionsDetails.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsDetails.vue?vue&type=style&index=0&id=9bf49c68&lang=scss&scoped=true&"
import style1 from "./TermsAndConditionsDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf49c68",
  null
  
)

export default component.exports